import BuildConfig from '@/environment';

export const CONFIG_APPLICATION_KEY = 'APPLICATION';
export const CONFIG_ENDPOINTS_KEY = 'ENDPOINTS';

export const TRANSACTION_APPL_START = 'START';
export const TRANSACTION_APPL_END = 'END';

export const TRANSACTION_CREATE_TYPE = 'CREATE';
export const TRANSACTION_UPDATE_TYPE = 'UPDATE';
export const TRANSACTION_DELETE_TYPE = 'DELETE';

export const TRANSACTION_ASC_ORDER = 'ASC';
export const TRANSACTION_DESC_ORDER = 'DESC';

export const TRANSACTION_EP_SORTBY_NAME = 'name';
export const TRANSACTION_EP_SORTBY_PRIORITY = 'priority';
export const TRANSACTION_EP_SORTBY_CREATEDAT = 'createdAt';
export const TRANSACTION_EP_MAXIMUM_GROUPING_LIST_COUNT =
  BuildConfig.VUE_APP_ENDPOINT_GROUP_LIMIT;
export const TRANSACTION_EP_MAXIMUM_EXCLUSION_LIST_COUNT =
  BuildConfig.VUE_APP_ENDPOINT_EXCLUDE_LIMIT;
export const TRANSACTION_EP_ENDPOINT_LIMIT_EXCEED_MSG =
  'Endpoint limit exceeded';

export const TRANSACTION_ACTION_HEADER = 'actions';

export const GROUPED_OPERATION_TYPE = 'G';
export const EXLCLUDE_OPERATION_TYPE = 'E';
export const EXCLUDE_WITH_METRICS_OP_TYPE = 'EM';
export const GROUPED_TRANSACTION_TYPE = 'GROUPED';
export const EXCLUDED_TRANSACTION_TYPE = 'EXCLUDED';
export const GROUPING_TRANSACTION = 'GROUPING';
export const EXCLUSION_TRANSACTION = 'EXCLUSION';
export const EM_ALIAS = 'Yes';
export const E_ALIAS = 'No';

export const CUSTOM_CLASS_TYPE = {
  POOR: 'poor',
  TANGERINE: 'tangerine',
};
